import { formatDisplayFullDate } from '@/config';
import { apiSdk } from '@/httpClient';
import { TicketReprintHistoryModel } from '@/__generated';
import { Modal, Table } from 'antd';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  ticketId: string;
  ticketRefNo?: string;
  onClose: () => void;
}

/** Réimpressions « Duplicata » d'un billet faites depuis l'app caissier : qui, quand, terminal, caisse, chef de gare. */
export default function TicketReprintsModal({ ticketId, ticketRefNo, onClose }: Props): ReactElement {
  const [t] = useTranslation();
  const [rows, setRows] = React.useState<TicketReprintHistoryModel[]>();
  React.useEffect(() => {
    apiSdk.TicketReprintService.ticketReprints({ ticketId })
      .then(setRows)
      .catch(() => setRows([]));
  }, [ticketId]);
  return (
    <Modal visible={true} width={760} title={`${t('ticketReprints_Title')} ${ticketRefNo || ''}`} footer={null} onCancel={onClose}>
      <Table<TicketReprintHistoryModel>
        rowKey="sequence"
        size="small"
        loading={rows === undefined}
        dataSource={rows || []}
        pagination={false}
        locale={{ emptyText: t('ticketReprints_None') }}
        columns={[
          { title: 'N°', dataIndex: 'sequence', width: 60 },
          { title: t('ticketReprints_Date'), dataIndex: 'reprintedOn', render: v => (v ? formatDisplayFullDate(v) : '') },
          { title: t('ticketReprints_Cashier'), dataIndex: 'reprintedBy' },
          { title: t('ticketReprints_Terminal'), dataIndex: 'terminal' },
          { title: t('ticketReprints_Register'), dataIndex: 'register' },
          { title: t('ticketReprints_ApprovedBy'), dataIndex: 'approvedBy', render: v => v || '—' },
        ]}
      />
    </Modal>
  );
}
